import {
  Anchor,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Container,
  Divider,
  Group,
  List,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'
import { LuCheck } from 'react-icons/lu'

export const Route = createFileRoute('/pricing')({
  component: PricingPage,
})

function PricingPage() {
  const tiers = [
    {
      name: 'Starter',
      price: 'Rp 1.500.000',
      period: '/bulan',
      hint: 'Untuk marina baru',
      features: [
        'Hingga 20 berth',
        'Hingga 500 customer',
        'Semua fitur core (Accounts, Reservations, Occupancy, Contracts, Billing)',
        'Email support',
        'Import data gratis',
      ],
      cta: 'Mulai Gratis 30 Hari',
      popular: false,
    },
    {
      name: 'Professional',
      price: 'Rp 3.500.000',
      period: '/bulan',
      hint: 'Untuk marina berkembang',
      features: [
        'Unlimited berth & customer',
        'Analytics + reports export',
        'Long-term contracts + digital signature',
        'Live chat customer portal',
        'WhatsApp support prioritas',
        'Custom branding (logo, email template)',
        'Data import + migration assistance',
      ],
      cta: 'Pilih Professional',
      popular: true,
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      period: '',
      hint: 'Untuk grup marina / chain',
      features: [
        'Multi-marina support',
        'Dedicated account manager',
        'SLA 99.9% + priority response',
        'Custom integration (accounting, ERP)',
        'White-label opsional',
        'Training on-site di Bali',
        'SSO + SAML',
      ],
      cta: 'Hubungi Sales',
      popular: false,
    },
  ]
  return (
    <Box style={{ minHeight: '100vh' }}>
      <Container size="xl" py="xl">
        <Breadcrumbs mb="lg">
          <Anchor component={Link} to="/" c="dimmed">
            Home
          </Anchor>
          <span>Harga</span>
        </Breadcrumbs>
        <Stack gap="xs" mb="xl" align="center">
          <Title order={1} ta="center">
            Harga Transparan
          </Title>
          <Text c="dimmed" size="lg" ta="center">
            Tanpa kartu kredit, cancel kapan saja.
          </Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, md: 3 }}>
          {tiers.map((t) => (
            <Card
              key={t.name}
              padding="xl"
              radius="md"
              style={
                t.popular
                  ? {
                      borderColor: 'var(--mantine-color-teal-6)',
                      borderWidth: 2,
                      boxShadow: '0 8px 32px rgba(31, 124, 106, 0.12)',
                    }
                  : undefined
              }
            >
              {t.popular && (
                <Badge color="laut" variant="filled" mb="md">
                  Paling Populer
                </Badge>
              )}
              <Text fw={700} fz="xl" mb={2}>
                {t.name}
              </Text>
              <Text size="sm" c="dimmed" mb="md">
                {t.hint}
              </Text>
              <Group align="baseline" gap={4} mb="md">
                <Text fw={700} fz="2.5rem">
                  {t.price}
                </Text>
                <Text size="sm" c="dimmed">
                  {t.period}
                </Text>
              </Group>
              <Divider mb="md" />
              <List
                size="sm"
                icon={
                  <ThemeIcon color="laut" size={16} radius="xl">
                    <LuCheck size={10} />
                  </ThemeIcon>
                }
                mb="xl"
                spacing="sm"
              >
                {t.features.map((f) => (
                  <List.Item key={f}>{f}</List.Item>
                ))}
              </List>
              <Button
                component={Link}
                to="/contact"
                color={t.popular ? 'teal' : 'gray'}
                variant={t.popular ? 'filled' : 'light'}
                fullWidth
                size="md"
              >
                {t.cta}
              </Button>
            </Card>
          ))}
        </SimpleGrid>

        <Box mt="xl" ta="center">
          <Text c="dimmed">
            Butuh lebih banyak detail?{' '}
            <Anchor component={Link} to="/contact" c="laut">
              Hubungi tim sales
            </Anchor>
          </Text>
        </Box>
      </Container>
    </Box>
  )
}
